import React from 'react';
import TONoEmailView from '../Views/TO/Apple/NoEmailView'
import AppVars from '../../AppVars.js'
import Logger from '../../Logger.js';

const appVars = AppVars.getInstance();
const logger = Logger.getInstance();


class NoEmail extends React.Component {
  constructor(props){
    super(props);
    this.state = {
    }
  }

  render(){
    return(
        /* FIXME: OnSubmit, the info is showing up in the URL */
        <div>
        <TONoEmailView style = {sessionStorage.AP_STYLE}
        />
        </div>
        



);

}

}

export default NoEmail;